import { gql } from '@generated/gql';

const getRegistrationToken = gql(`
    query PartnerRegistrationToken($basketID: ID!) {
        partnerRegistrationToken(basketId: $basketID) {
            token
        }
    }`);

const reservedBroadbandAppointment = gql(`
    query ReservedBroadbandAppointment(
      $basketId: ID!
    ) {
      reservedBroadbandAppointment(basketId: $basketId) {
        date
        slot
      }
    }
  `);

export { getRegistrationToken, reservedBroadbandAppointment };
